import React from 'react';
import './HorizontalBar.css';

export default function HorizontalBar() {
  return (
    <div className='horizontalBar'>
      
    </div>
  )
}
